module.exports = __webpack_public_path__ + "static/img/tf.d82ec644.svg";